import { useTerminalCards } from '@api/useTerminalCards'
import { ValueEditor } from '@components/Admin/Location/Cards/components/BulkChangeEditor/ValueEditor'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Form, Select, Tooltip } from 'antd'
import React, { useMemo, useState } from 'react'

export function BulkChangeBar({ selectedRows, onBulkChangeBarClosed, setSelectedProperty, selectedProperty }) {
  const [numberValue, setNumberValue] = useState('')

  const { useBulkCardUpdate } = useTerminalCards()
  const [form] = Form.useForm()
  const handleClose = () => {
    form.resetFields()
    setSelectedProperty(null)
  }
  const numberInputProperties = ['activity_threshold', 'warning_threshold', 'days_valid']

  const onFinish = async (values) => {
    const { property, value: formValue } = values
    const card_ids = selectedRows.map((row) => row?.id)
    let value = formValue
    if (numberInputProperties.includes(property)) {
      value = parseInt(numberValue)
    }
    const payload = { card_ids, property, value: !!value || value === 0 ? value : null }

    const results = await useBulkCardUpdate.mutateAsync(payload)
    form.resetFields()
    onBulkChangeBarClosed(results)
  }
  const propertyOptions = useMemo(
    () => [
      { label: 'Card Name', value: 'name' },
      { label: 'Activity', value: 'activity' },
      { label: 'Certification Trigger', value: 'certification_trigger' },
      { label: 'Activity Threshold', value: 'activity_threshold' },
      { label: 'Days Valid', value: 'days_valid' },
      { label: 'Warning Threshold', value: 'warning_threshold' },
      { label: 'Dispatch Impact', value: 'dispatch_impact' },
      { label: 'Carding Instructions', value: 'carding_instructions' },
    ],
    []
  )
  const handleValuesChange = (changedValues) => {
    if ('property' in changedValues) {
      form.setFieldsValue({ value: null })
      setSelectedProperty(changedValues.property)
    }
  }

  return (
    <Form form={form} onFinish={onFinish} layout='inline' onValuesChange={handleValuesChange}>
      <Horizontal className='full-height-width ' verticalCenter alignItems='space-between'>
        <Horizontal
          horizontalCenter
          verticalCenter
          className='px-4 py-3 mb-3 mt-3 border-bottom border-top border-left'
          style={{
            backgroundColor: 'var(--theme-color-1)',
            borderRadius: '3px 0 0 3px',
            height: '60px',
            width: '275px',
          }}
        >
          <Texto appearance='white' category='h5'>
            UPDATE TERMINAL CARD
          </Texto>
        </Horizontal>
        <Horizontal
          flex={1}
          style={{ height: '60px' }}
          verticalCenter
          className='bg-1 px-4 py-2 mb-3 mt-3 border-bottom border-top'
        >
          <Form.Item name='property' label='Property' rules={[{ required: true, message: 'Property is required.' }]}>
            <Select options={propertyOptions} style={{ width: '200px' }} />
          </Form.Item>

          <ValueEditor
            property={selectedProperty}
            setNumberValue={setNumberValue}
            numberValue={numberValue}
            numberInputProperties={numberInputProperties}
          />
        </Horizontal>
        <Horizontal
          flex={0}
          justifyContent='flex-end'
          verticalCenter
          className='bg-1 px-4 py-2 mb-3 mt-3 border-bottom border-top border-right'
          style={{ borderRadius: '0 3px 3px 0', height: '60px' }}
        >
          <GraviButton
            buttonText='Cancel'
            onClick={() => {
              handleClose()
              onBulkChangeBarClosed()
            }}
            className='square-ish mr-4'
          />
          <Tooltip title='Select rows to update'>
            <GraviButton
              className='square-ish mr-4'
              onClick={() => selectedRows?.length && form.submit()}
              buttonText='Confirm'
              theme1
              disabled={!selectedRows?.length}
            />
          </Tooltip>
        </Horizontal>
      </Horizontal>
    </Form>
  )
}
